import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RecentTransactions = ({ transactions }) => {
  const getTransactionIcon = (type) => {
    switch (type) {
      case 'buy':
        return { name: 'ArrowDownToLine', color: 'text-success' };
      case 'sell':
        return { name: 'ArrowUpFromLine', color: 'text-error' };
      case 'deposit':
        return { name: 'Plus', color: 'text-brand-secondary' };
      case 'withdrawal':
        return { name: 'Minus', color: 'text-warning' };
      default:
        return { name: 'ArrowRightLeft', color: 'text-muted-foreground' };
    }
  };

  const formatAmount = (amount, type) => {
    const prefix = type === 'buy' || type === 'deposit' ? '+' : '-';
    return `${prefix}$${Math.abs(amount)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-md border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl md:text-2xl font-bold text-foreground">Recent Transactions</h3>
        <button className="text-sm md:text-base text-primary hover:text-primary/80 font-medium transition-colors">
          View All
        </button>
      </div>
      <div className="space-y-4">
        {transactions?.map((transaction) => {
          const icon = getTransactionIcon(transaction?.type);
          return (
            <div 
              key={transaction?.id} 
              className="flex items-center gap-4 p-4 bg-muted rounded-lg hover:bg-muted/80 transition-colors"
            >
              <div className="flex-shrink-0">
                {transaction?.cryptoIcon ? (
                  <Image 
                    src={transaction?.cryptoIcon} 
                    alt={transaction?.cryptoIconAlt}
                    className="w-10 h-10 md:w-12 md:h-12 rounded-full"
                  />
                ) : (
                  <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full bg-background flex items-center justify-center ${icon?.color}`}>
                    <Icon name={icon?.name} size={20} />
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-semibold text-foreground truncate">
                  {transaction?.description}
                </p>
                <p className="text-xs md:text-sm text-muted-foreground">
                  {transaction?.date} • {transaction?.time}
                </p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className={`text-sm md:text-base font-bold ${transaction?.type === 'buy' || transaction?.type === 'deposit' ? 'text-success' : 'text-error'}`}>
                  {formatAmount(transaction?.amount, transaction?.type)}
                </p>
                {transaction?.cryptoAmount && (
                  <p className="text-xs md:text-sm text-muted-foreground whitespace-nowrap">
                    {transaction?.cryptoAmount}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentTransactions;